const routes = [
  {
    path: "/manutencao-funcao-local-lotacao",
    name: "manutencao-funcao-local-lotacao",
    meta: {
      allowedPermissions: ["funcao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoFuncaoLocalLotacao/ManutencaoFuncaoLocalLotacaoHome.vue"
      ),
  },
  {
    path: "/manutencao-funcao-local-lotacao/novo",
    name: "manutencao-funcao-local-lotacao-novo",
    meta: {
      allowedPermissions: ["funcao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoFuncaoLocalLotacao/ManutencaoFuncaoLocalLotacaoCad.vue"
      ),
  },
  {
    path: "/manutencao-funcao-local-lotacao/editar/:id",
    name: "manutencao-funcao-local-lotacao-editar",
    meta: {
      allowedPermissions: ["funcao_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoFuncaoLocalLotacao/ManutencaoFuncaoLocalLotacaoEdit.vue"
      ),
  },
];

export default routes;
